import { Form, FormItemProps } from "antd";
import { NamePath } from "antd/lib/form/interface";

interface MyFormItemProps extends FormItemProps {
  label: React.ReactNode;
  name: NamePath;
}

export const MyFormItem: React.FC<MyFormItemProps> = ({
  label,
  children,
  ...props
}) => {
  return (
    <Form.Item
      label={<span className="font-semibold">{label}</span>}
      className="my-form-item mb-0"
      {...props}
    >
      {children}
    </Form.Item>
  );
};
